import { computed } from "vue";
import { createQuery } from "@/queries";
import { useTokenStore } from "@/features/auth/store";
import { fetchAuthUserInfo } from "@/features/auth/api/profile";
import type { AxiosResponse } from "axios";

type UserInfoResponse = Awaited<ReturnType<typeof fetchAuthUserInfo>> extends AxiosResponse<infer T>
  ? T
  : never;

export const useUserInfoQuery = () => {
  const tokenStore = useTokenStore();
  return createQuery<UserInfoResponse>({
    key: ["userInfo"],
    fetcher: async () => {
      const response = await fetchAuthUserInfo();
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    // a guest has no account to describe: the call only answered 401 on every page
    enabled: computed(() => Boolean(tokenStore.accessToken)),
  });
};

